import React from 'react';

import {lazy} from '@aboutyou/lazy-imports';
import {CheckoutLoadingSpinner} from '@aboutyou/logic-components';

export const CheckoutPage = lazy(
  () =>
    import('./CheckoutPage.eager').then(mod => ({
      default: mod.CheckoutPageEager,
    })),
  {
    fallback: <CheckoutLoadingSpinner />,
    aboveTheFold: true,
  },
);
